// extracted by mini-css-extract-plugin
export default {"sticker":"Mayday_sticker__Yo3lY"};